var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAllMute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "c",
    width: 10,
    height: 10,
    x: 0,
    y: 0,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M17,0 C17.5522847,0 18,0.44771525 18,1 L18,17 C18,17.5522847 17.5522847,18 17,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,1 C0,0.44771525 0.44771525,0 1,0 L17,0 Z M17,1 L1,1 L1,17 L17,17 L17,1 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#B1B1B1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#CBCBCB",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "#B1B1B1",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#979797",
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAllMute);
export default __webpack_public_path__ + "static/media/icon_all_mute.4bd5426a2b517830e06e92d5263afd86.svg";
export { ForwardRef as ReactComponent };